// Firebase Firestore Schema
export namespace FSSchema {
	export enum collections {
		/** Para almacenar los mensajes enviados por el monitor
		 * @path /monitoring/:pgid/tests/:tid/test/:_id/msg
		 */
		monitoring = "monitoring",
		/**
		 * Para almacenar los usuarios conectados a la prueba
		 * @path /users_connected/:pgid/rooms/:room/monitors/:uid
		 */
		users_connected = "users_connected",
		/**
		 * Para almacenar las pruebas completadas
		 * @path /assessments/:_id
		 */
		assessments = "assessments",

		/**
		 * Para almacenar las llamadas
		 * @path /calls/:_id
		 */
		calls = "calls"
	}
	export namespace users_connected {
		export namespace $pgid {
			export namespace rooms {
				export namespace $room {
					export namespace monitors {
						export namespace $uid {
							export interface _doc {
								connected: number;
							}

							export namespace watching {
								export namespace $participantId {
									export interface _doc {
										id: string;
										name: string;
										type: "person" | "screen";
										role: "sender" | "receiver";
										joinedAt: string;
										offers?: Record<string, RTCSessionDescriptionInit>;
										answers?: Record<string, RTCSessionDescriptionInit>;
										iceCandidates?: Record<string, RTCIceCandidateInit[]>;
										signal?: Record<string, "ping" | "pong" | null>;
									}
								}
							}
						}
					}
				}
			}
		}
	}
	export interface monitoring {}
}
